import { Vue } from 'vue/types/vue'
import { GET_TRANSLATIONS } from '~/graphql/gql/translation'
import { getRouteDefinition } from '~/utils/routesGetDefinition'

export const defaultLanguage = '_'

const DEFAULT_TRANSLATION = ['common']

export const apolloServiceTranslation = (
  translateSpace: string[] = [],
  options?: object
) => {
  const message = DEFAULT_TRANSLATION.concat(translateSpace)
  return {
    getTranslations: apolloServiceTranslationQuery(message, options),
  }
}

export const apolloServiceTranslationQuery = (
  translateSpace: string[] = [],
  options?: object
) => {
  return {
    fetchPolicy: 'cache-first',
    query: GET_TRANSLATIONS,
    update(data: any) {
      const context = this as any
      context._i18n.mergeLocaleMessage(defaultLanguage, data.getTranslations)
      return data
    },
    variables: {
      namespaces: translateSpace,
    },
    ...options,
  }
}

export const apolloServerTranslationPage = (route: Vue['$route']) => {
  if (!route.name) {
    return DEFAULT_TRANSLATION
  }

  const translations = getRouteDefinition(route)?.translations || []

  return DEFAULT_TRANSLATION.concat(translations)
}
